// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f13a423e5ab58718430f","691":"0eda04d2bfaceb09bbbc"}[chunkId] + ".js";
};